module.exports = __webpack_public_path__ + "static/media/031-star.0da88c4f.svg";